import axios from 'axios';
import CompanySettingsData from '../models/company-settings-data.model';

export const getCompanySettings = (): any => {
    const url = 'CompanySettings';
    return axios.get<CompanySettingsData>(url);
};
